import { SET_SERVICE_TYPE } from 'actions';
import { ServiceType } from 'typings';

export function setServiceType(serviceType: ServiceType) {
  return { serviceType, type: SET_SERVICE_TYPE };
}
